@if (!data) {
  <div class="row">
    <div class="col-md-7">
      @if (!showError) {
        <div>
          <div class="content">
            <p>
              Please specify flight type and destination in order to provide accurate fuel quote
            </p>
          </div>
          <div class="row">
            <div class="col-md-10">
              <form [formGroup]="form"
                (ngSubmit)="onSubmit()"
                class="form-container login-request-form">
                <mat-form-field class="w-100">
                  <mat-label>Flight type</mat-label>
                  <mat-select formControlName="flightType">
                    @for (i of flightTypeList; track i) {
                      <mat-option
                        [value]="i.value">
                        {{i.label}}
                      </mat-option>
                    }
                  </mat-select>
                  @if (form.get('flightType').hasError('required')) {
                    <mat-error>
                      Please select an option
                    </mat-error>
                  }
                </mat-form-field>
                <mat-form-field class="w-100">
                  <mat-label>Destination type</mat-label>
                  <mat-select formControlName="departureType">
                    @for (i of destinationTypeList; track i) {
                      <mat-option
                        [value]="i.value">
                        {{i.label}}
                      </mat-option>
                    }
                  </mat-select>
                  @if (form.get('departureType').hasError('required')) {
                    <mat-error>
                      Please select an option
                    </mat-error>
                  }
                </mat-form-field>
                <button type="submit" class="btn btn-primary" [disabled]="loading">
                  @if (loading) { <span class="spinner-border spinner-border-sm me-1"></span> }
                  Request quote
                </button>
              </form>
            </div>
          </div>
        </div>
      } @else {
        <div class="simple-title error">
          Oops!
        </div>
        <div class="content">
          <p>
            Something went wrong, fuel quote is currently unavailable, please try again later.
          </p>
        </div>
      }
    </div>
  </div>
} @else {
  <app-quote-details [data]="data" />
}


